var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 11,
    viewBox: "0 0 15 11",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.476131 4.97613C0.186808 5.26546 0.186808 5.73454 0.476131 6.02387L5.19095 10.7387C5.48027 11.028 5.94936 11.028 6.23868 10.7387C6.52801 10.4494 6.52801 9.98027 6.23868 9.69095L2.04774 5.5L6.23868 1.30905C6.52801 1.01973 6.52801 0.550642 6.23868 0.261317C5.94936 -0.028007 5.48027 -0.028007 5.19095 0.261317L0.476131 4.97613ZM15 4.75914L1 4.75914V6.24086L15 6.24086V4.75914Z",
    fill: "#573B76"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.ea3f2a491f36dea833b478218295e55b.svg";
export { ForwardRef as ReactComponent };